import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { APIService } from '../shared/service/api.service';
import { FormularioService } from '../sugestoes/form.service';

@Component({
  selector: 'app-inclusao-experimental',
  templateUrl: './inclusao-experimental.component.html',
  styleUrls: ['./inclusao-experimental.component.scss']
})
export class InclusaoExperimentalComponent implements OnInit {
  formulario: FormGroup;
  eixos: any[];
  areasTecnologicas: any;
  textoTermo: string;
  fileError: string;
  fileName: string;
  pdf: any;
  mostarPopUp: boolean;
  resposta: any;
  formularioRecebido: boolean;
  erro = false;

  constructor(private api: APIService,  private formService: FormularioService, ) {}

  ngOnInit(): void {
    this.textoTermo = this.formService.getFormFields().textoTermo;

    this.api.getEixos().subscribe(response => {
      this.eixos = response;
    });

    this.criarFormulario();
    this.subscribeForms();
  }

  criarFormulario() {
    this.formulario = new FormGroup({
      nomeInstituicao: new FormControl(null, Validators.required),
      enderecoLocalOferta: new FormControl(null, Validators.required),
      site: new FormControl(null, Validators.required),
      reponsavelPreenchimentoNome: new FormControl(null, Validators.required),
      reponsavelPreenchimentoEmail: new FormControl(null, [Validators.required, Validators.email]),
      tituloCurso: new FormControl(null, Validators.required),
      codigoSistemaOfertante: new FormControl(null),
      nomeSistemaOfertante: new FormControl(null),
      codCine: new FormControl(null, Validators.required),
      eixoTecnologicoCncstId: new FormControl(null, Validators.required),
      tituloEstaTabelaConvergencia: new FormControl(false, Validators.required),
      justificativaOfertaCurso: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      cargaHoraria: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      haPreRequisito: new FormControl('sim', Validators.required),
      preRequisitoIngresso: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      perfilProfissional: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      eVerticalizacaoCurso: new FormControl('sim', Validators.required),
      verticalizadoCursoTecnico: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      haSaidasIntermediarias: new FormControl('sim', Validators.required),
      saidasIntermediariasPropostas: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      campoAtuacaoProfissional: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      existeLegislacao: new FormControl('sim', Validators.required),
      legislacaoAssociada: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      ocupacoesCbo: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      infraestruturaMinima: new FormControl('', [Validators.required, Validators.maxLength(5000)]),
      numeroVagasAutorizadasPorAno: new FormControl(null, Validators.required),
      file: new FormControl(null, Validators.required),

      matriculasPublicadasCenso2015: new FormControl(null, Validators.required),
      matriculasPublicadasCenso2016: new FormControl(null, Validators.required),
      matriculasPublicadasCenso2017: new FormControl(null, Validators.required),
      matriculasPublicadasCenso2018: new FormControl(null, Validators.required),
      matriculasPublicadasCenso2019: new FormControl(null, Validators.required),

      aceitaTermo: new FormControl(false, Validators.requiredTrue),
      reCaptcha: new FormControl(null, Validators.required),
    });
  }

  subscribeForms() {
    this.formulario.get('haPreRequisito').valueChanges.subscribe(value => {
      if (value === 'nao') {
        this.formulario.get('preRequisitoIngresso').clearValidators();
        this.formulario.get('preRequisitoIngresso').updateValueAndValidity();
      }
      else {
        this.formulario.get('preRequisitoIngresso').setValidators([Validators.required]);
        this.formulario.get('preRequisitoIngresso').updateValueAndValidity();
      }
    });

    this.formulario.get('eVerticalizacaoCurso').valueChanges.subscribe(value => {
      if (value === 'nao') {
        this.formulario.get('verticalizadoCursoTecnico').clearValidators();
        this.formulario.get('verticalizadoCursoTecnico').updateValueAndValidity();
      }
      else {
        this.formulario.get('verticalizadoCursoTecnico').setValidators([Validators.required]);
        this.formulario.get('verticalizadoCursoTecnico').updateValueAndValidity();
      }
    });

    this.formulario.get('haSaidasIntermediarias').valueChanges.subscribe(value => {
      if (value === 'nao') {
        this.formulario.get('saidasIntermediariasPropostas').clearValidators();
        this.formulario.get('saidasIntermediariasPropostas').updateValueAndValidity();
      }
      else {
        this.formulario.get('saidasIntermediariasPropostas').setValidators([Validators.required]);
        this.formulario.get('saidasIntermediariasPropostas').updateValueAndValidity();
      }
    });

    this.formulario.get('existeLegislacao').valueChanges.subscribe(value => {
      if (value === 'nao') {
        this.formulario.get('legislacaoAssociada').clearValidators();
        this.formulario.get('legislacaoAssociada').updateValueAndValidity();
      }
      else {
        this.formulario.get('legislacaoAssociada').setValidators([Validators.required]);
        this.formulario.get('legislacaoAssociada').updateValueAndValidity();
      }
    });
  }

  fileChange(event: any) {
    this.fileError = null;
    this.fileName = null;
    this.pdf = null;
    const file = event.target.files[0];

    if (file.type !== 'application/pdf') {
      this.fileError = 'Formato de arquivo não suportado.';
      this.formulario.get('file').setErrors({ formatNotAllowed: true });
      return;
    }

    if (file.size > 20000000) {
      this.fileError = `O arquivo deve conter um máximo de 20MB.
      O arquivo que você selecionou possui ${(file.size / 1048576).toFixed(2)}MB`;
      this.formulario.get('file').setErrors({ manyFiles: true });
      return;
    }

    this.fileName = file.name;
    this.pdf = file;
  }

  cancelar() {
    if (this.formularioRecebido){
      window.location.reload();
      return;
    }
    this.mostarPopUp = false;
  }

  onSubimitFormulario() {
    this.erro = false;

    if (this.formulario.invalid) {
      this.formulario.markAllAsTouched();
      return;
    }

    const url = window.location.href;
    let form = {
      ...this.formulario.value,
      linkFormulario: url
    };

    form.arquivoPpcAutorizado = this.fileName;

    if (form.tituloEstaTabelaConvergencia === false) {
      form.tituloEstaTabelaConvergencia = 0;
    }
    else {
      form.tituloEstaTabelaConvergencia = 1;
    }

    form = JSON.stringify(form);

    const postForm = new FormData();
    postForm.append('sugestao', form);
    postForm.append('file', this.pdf);

    this.mostarPopUp = true;

    this.api.postInclusaoExperimental(postForm).subscribe(response => {
      setTimeout(() => {
        this.resposta = response;
        this.formularioRecebido =  true;
      }, 300);
    },
    error => {
      this.erro = true;
    });
  }

}
